import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { compactString } from '../../../utils/helpers/string'
import { ACTIVITY_TAG_TYPE } from '../../../modules/tags/_constants'
import FilterLink from '../../../components/filter/FilterLink'
import TagSelect from '../select/TagSelect'

/**
 * Filtro multi-tag da listagem/kanban de Atividades, no mesmo padrão dos demais filtros
 * multi-valor (`field` terminado em `Ids`, ex.: `statusIds`) já usados em `ServiceOrderFiltersList`.
 * Reaproveita o `TagSelect` (autocomplete já paginado) em vez de um modal picker dedicado, já que
 * o volume de tags de atividade tende a ser pequeno.
 */
const TagsFilterV2 = ({ field, type, ...props }) => {
  const { t } = useTranslation('common')
  field = field || 'tagIds'
  type = type || ACTIVITY_TAG_TYPE
  const label = t('tag')
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()
  const [open, setOpen] = React.useState(false)

  return (
    <div>
      <FilterLink icon="BsTagFill" label={label} value={compactString(value, { t })} onClick={() => setOpen(!open)} />
      {open && (
        <TagSelect
          autoFocus
          multiple
          type={type}
          allowCreate={false}
          value={value}
          onClose={() => setOpen(false)}
          onChange={handleChange(field)}
          {...props}
        />
      )}
    </div>
  )
}

export default TagsFilterV2
